import { c as _c } from "react/compiler-runtime";
import { FormSelectInline } from '@systemeio/ui';
import { useEmailList } from 'modules/profile/mailing-settings/hooks/use-email-list';
import { EmailItemInterface } from 'modules/profile/mailing-settings/types/email-list-interface';
import { FC, useEffect, useState } from 'react';
import { CopyToClipboardButton } from 'shared/components/copy-to-clipboard-button';
interface DmarcProps {
  isReady: boolean;
}
export const DMARC_KEY = '_dmarc';
const DMARC_STATIC = 'v=DMARC1; p=none; rua=mailto:';
const Dmarc: FC<DmarcProps> = t0 => {
  const $ = _c(18);
  const {
    isReady
  } = t0;
  const {
    data: emailList
  } = useEmailList(isReady);
  const [emailItem, setEmailItem] = useState();
  let t1;
  if ($[0] !== emailList) {
    t1 = emailList?.map(_temp);
    $[0] = emailList;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectData = t1;
  const dmarc = DMARC_STATIC + emailItem?.email;
  let t2;
  let t3;
  if ($[2] !== emailList) {
    t2 = () => {
      if (emailList && emailList.length > 0) {
        setEmailItem(emailList[0]);
      }
    };
    t3 = [emailList];
    $[2] = emailList;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span>{DMARC_STATIC}</span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = emailItem?.id;
  let t6;
  if ($[6] !== emailList) {
    t6 = data => {
      if (emailList) {
        const selectedEmail = emailList.find(email_0 => email_0.id === data);
        setEmailItem(selectedEmail);
      }
    };
    $[6] = emailList;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== selectData || $[9] !== t5 || $[10] !== t6) {
    t7 = <FormSelectInline value={t5} onChange={t6} data={selectData} withoutCloseIcon={true} arrowButtonClassName="h-[20px]" />;
    $[8] = selectData;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = !emailItem;
  let t9;
  if ($[12] !== dmarc || $[13] !== t8) {
    t9 = <CopyToClipboardButton className="[&_svg]:fill-brand-primary/70 ml-1.5" text={dmarc} disabled={t8} />;
    $[12] = dmarc;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <div className="flex w-full select-none items-center">{t4}{t7}{t9}</div>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default Dmarc;
function _temp(email) {
  return {
    id: email.id,
    caption: email.email
  };
}